import PropTypes from 'prop-types';
import BackLink from '../backLink';
import AuthFormLayout from '../authFormLayout';
import { ReactComponent as TonalityIcon } from '../../../assets/icons/tonality.svg';
import fields from './fields';

const LoginFormLayout = props => {
  const { translations } = props;

  const onSubmit = e => {
    e.preventDefault();
    props.submitForm();
  };

  return (
    <AuthFormLayout
      {...props}
      handleSubmit={onSubmit}
      subtitleVariant="body1"
      icon={TonalityIcon}
      fields={fields}
    >
      <BackLink
        title={translations.backLink}
        navigate={props.navigate}
        to="/forgotten-password"
      />
    </AuthFormLayout>
  );
};

LoginFormLayout.propTypes = {
  translations: PropTypes.object.isRequired,
};

export default LoginFormLayout;
